<template>
  <div class="page-header">
    <div class="left">
      <!-- <v-btn
        v-if="isShowBackBtn"
        icon
        depressed
        dark
        class="btn-back"
        @click="$emit('clickBack')"
      >
        <v-icon dark>mdi-arrow-left</v-icon>
      </v-btn> -->
    </div>
    <!-- <div class="header-logo"><img src="@/assets/images/common/bayer_logo_white.png" alt=""></div> -->
    <div class="center">
      <h3 class="page-title" style="white-space: pre-line">{{ headTitle }}</h3>
    </div>
    <div class="right">
      <v-btn
        v-if="isShowBackBtn"
        icon
        depressed
        dark
        class="btn-close right"
        @click="$emit('clickBack')"
      >
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="loginOut" v-if="isShowLoginBtn">
      <span v-if="isAuthorized">
        <span @click="$emit('clickUserInfo')"><v-icon>mdi-menu</v-icon></span>
      </span>
      <p v-else @click="$emit('clickLogIn')">로그인</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    isShowBackBtn: {
      type: Boolean,
      default: false,
    },
    headTitle: {
      type: String,
      default: "",
    },
    isShowLoginBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["isAuthorized"]),
  },
  methods: {},
};
</script>

<style lang="scss">
.page-header {
  position: fixed;   /* 상단 고정 */
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;     /* 다른 요소들 위에 표시 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  background-color: #d9f0d4;
  border-radius: 0 0 24px 24px;
  padding: 0 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .left,
  .right {
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    min-width: 320px;
  }
  .page-title {
    color: $primary-color;
    font-size: 1.2rem;
    margin: auto;
  }
  .v-icon {
    color: #ffffff;
  }
  .btn-back {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
  }
  .btn-close {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
  }
}

.loginOut {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
}
</style>
